import { ApiResult } from "common/models";
import { HttpClient } from "common/services/http-client.service";
import { withApiResponse } from "common/utils/rtk-query.util";
import { knowledgeAgentConfig } from "../config/knowledge-agent.config";
import {
  AnalyseDocumentsRequest,
  AnalyseDocumentsResponse,
  DocumentApiResponse,
  ReferenceStandardApiItem,
  ResumeSpecAuditRequest,
  SpecAuditSessionResponse,
  StartPackageRequest,
  StartPackageResponse,
  TriggerSpecAuditRequest
} from "../models/knowledge-agent.model";

export class KnowledgeAgentService extends HttpClient {
  public static getAdminDocuments() {
    const config = knowledgeAgentConfig.getAdminDocuments();
    return withApiResponse<DocumentApiResponse>(async () => {
      const response = await this.invokeApi<DocumentApiResponse>(config);
      return new ApiResult<DocumentApiResponse>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static analyseDocuments(request: AnalyseDocumentsRequest) {
    const config = knowledgeAgentConfig.analyseDocuments(request);
    return withApiResponse<AnalyseDocumentsResponse>(async () => {
      const response = await this.invokeApi<AnalyseDocumentsResponse>(config);
      return new ApiResult<AnalyseDocumentsResponse>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static getAllReferenceStandards() {
    const config = knowledgeAgentConfig.getAllReferenceStandards();
    return withApiResponse<ReferenceStandardApiItem[]>(async () => {
      const response = await this.invokeApi<ReferenceStandardApiItem[]>(config);
      return new ApiResult<ReferenceStandardApiItem[]>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static triggerSpecAuditSession(request: TriggerSpecAuditRequest) {
    const config = knowledgeAgentConfig.triggerSpecAuditSession(request);
    return withApiResponse<any>(async () => {
      const response = await this.invokeApi<any>(config);
      return new ApiResult<any>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static uploadReferenceStandard(file: File) {
    const config = knowledgeAgentConfig.uploadReferenceStandard(file);
    return withApiResponse<any>(async () => {
      const response = await this.invokeApi<any>(config, {
        "Content-Type": "multipart/form-data"
      });
      return new ApiResult<any>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static getSpecAuditSession(sessionId: string) {
    const config = knowledgeAgentConfig.getSpecAuditSession(sessionId);
    return withApiResponse<SpecAuditSessionResponse>(async () => {
      const response = await this.invokeApi<SpecAuditSessionResponse>(config);
      return new ApiResult<SpecAuditSessionResponse>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static getAllSpecAuditSessions() {
    const config = knowledgeAgentConfig.getAllSpecAuditSessions();
    return withApiResponse<SpecAuditSessionResponse[]>(async () => {
      const response = await this.invokeApi<SpecAuditSessionResponse[]>(config);
      return new ApiResult<SpecAuditSessionResponse[]>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static resumeSpecAuditSession(request: ResumeSpecAuditRequest) {
    const config = knowledgeAgentConfig.resumeSpecAuditSession(request);
    return withApiResponse<any>(async () => {
      const response = await this.invokeApi<any>(config);
      return new ApiResult<any>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static startPackage(request: StartPackageRequest) {
    const config = knowledgeAgentConfig.startPackage(request);
    return withApiResponse<StartPackageResponse>(async () => {
      const response = await this.invokeApi<StartPackageResponse>(config);
      return new ApiResult<StartPackageResponse>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }
}
